import * as React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import Layout from './sidebar/Layout';

import ConsultantHomePage from 'pages/consultant/homepage';
import ConsultantInProgressProjects from 'pages/consultant/InProgressProjects';
import ConsultantDelayedProjects from 'pages/consultant/DelayedProjects';
import ConsultantValidatedProjects from 'pages/consultant/ValidatedProjects';
import ConsultantProjectDisplay from 'pages/consultant/ProjectDisplay';
import AdminClientTextDisplay from 'pages/AdminClient/AdminClientTextDisplay';
import ConsultantProfile from 'pages/consultant/ConsultantProfile';
import ConsultantIASmartcontent from 'pages/consultant/ConsultantIASmartcontent';
import CreateIASmartText from 'pages/AdminClient/RedactionIA/createIAsmarttext';
import CreateTraductionIA from 'components/shared/traductionIa/createtraductionIA';
import TraductionIaList from 'components/shared/traductionIa/traductionIalist';
import { CONSULTANT_PROJECT_ROUTES } from 'pages/consultant/projects/constants';

export default class ConsultantMainMenu extends React.Component {
  render() {
    return (
      <Layout>
        <Switch>
          <Route
            exact
            path="/Consultant/MainMenu"
            render={(props) => <ConsultantHomePage {...props} reload={true} />}
          />

          <Route
            exact
            path="/Consultant/ProjectsEnCours"
            component={ConsultantInProgressProjects}
          />

          <Route
            exact
            path="/Consultant/ProjectsEnRetard"
            component={ConsultantDelayedProjects}
          />

          <Route
            exact
            path="/Consultant/ProjectsValides"
            component={ConsultantValidatedProjects}
          />

          <Route
            exact
            path="/Consultant/DetailsProject"
            component={ConsultantProjectDisplay}
          />

          <Route
            path="/Consultant/TextDetails"
            component={AdminClientTextDisplay}
          />

          <Route
            exact
            path={CONSULTANT_PROJECT_ROUTES.IA_SMART}
            component={ConsultantIASmartcontent}
          />
          <Route
            path={`${CONSULTANT_PROJECT_ROUTES.CREATE_IA_SMART_TEXT}/:id`}
            component={CreateIASmartText}
          />
          <Route
            exact
            path={CONSULTANT_PROJECT_ROUTES.TRANSLATION_IA}
            component={TraductionIaList}
          />
          <Route
            exact
            path={CONSULTANT_PROJECT_ROUTES.CREATE_TRANSLATION_IA}
            render={(props) => <CreateTraductionIA {...props} mode="consultant" />}
          />

          <Route
            exact
            path="/Consultant/MonProfil"
            component={ConsultantProfile}
          />

          <Route path="*">
            <Redirect to="/Consultant/MainMenu" />
          </Route>
        </Switch>
      </Layout>
    );
  }
}
